import React from 'react'

const Loading = () => {
  const BASE_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PRODUCTION_HEAD : ''
  return (
    // <span style={{ textAlign: 'center' }}>
      <img src={BASE_URL + '/img/loading.svg'} alt="Loading..." style={{ marginTop: '10px', maxHeight: '24px' }} />
    // </span>
  )
}

export default Loading



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js